import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const KNOWN_MODAL_CLASSES = [
    'showCreationLocationModal',
    'showImportCollectionModal',
    'showBimboShareModal',
    'modal-open',
    'offcanvas-open',
    'on-drag',
    'onDrag',
]

/**
 * Safely cleans up residual body classes, inline scroll locks, and stranded backdrop elements on route navigation.
 */
export const useRouteCleanup = () => {
    const location = useLocation()

    useEffect(() => {
        KNOWN_MODAL_CLASSES.forEach((cls) => document.body.classList.remove(cls))
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''

        const backdropElements = document.querySelectorAll('.modal-backdrop, .offcanvas-backdrop')
        backdropElements.forEach((el) => el.remove())
    }, [location.pathname, location.search])
}

export default useRouteCleanup
